import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'institutionfilter'
})
export class InstitutionfilterPipe implements PipeTransform {

  transform(institutions: any, searchTerm: string): any {
    if (!searchTerm) {
      return null;
    }

   // tslint:disable-next-line:max-line-length
   return institutions.filter(institution => institution.shortName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1 || institution.name.indexOf(searchTerm) !== -1);
  }

}
